import { render, staticRenderFns } from "./ProfileTypeBadge.vue?vue&type=template&id=1c160fb6"
import script from "./ProfileTypeBadge.vue?vue&type=script&lang=js"
export * from "./ProfileTypeBadge.vue?vue&type=script&lang=js"
import style0 from "./ProfileTypeBadge.vue?vue&type=style&index=0&id=1c160fb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports